var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoPhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 175,
    viewBox: "0 0 197 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2146_63583)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_2146_63583)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4934 57.3319H77.2992C81.0169 57.3319 80.893 57.4592 82.5215 54.7657L85.2631 50.2154C86.8774 47.552 87.9302 45.8027 91.7509 46.0179H105.015H118.279C122.1 45.8027 123.152 47.552 124.767 50.2154L127.508 54.7657C129.137 57.458 129.014 57.3319 132.731 57.3319H141.755C143.801 57.3319 145.475 59.0986 145.475 61.2564V115.078C145.475 117.237 143.801 119.002 141.755 119.002H98.6236H55.4923C53.446 119.002 51.7725 117.235 51.7725 115.078V61.2564C51.7725 59.0974 53.446 57.3319 55.4923 57.3319H55.4934Z",
    fill: "#38A6DE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7614 54.1084H71.22C71.7332 54.1084 72.1543 54.5515 72.1543 55.0941V57.3121V57.334H60.8281V57.3121V55.0941C60.8281 54.5515 61.2481 54.1084 61.7625 54.1084H61.7614Z",
    fill: "#165B95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.921 115.136C120.916 115.136 133.071 102.197 133.071 86.2352C133.071 70.2735 120.916 57.334 105.921 57.334C90.9269 57.334 78.7715 70.2735 78.7715 86.2352C78.7715 102.197 90.9269 115.136 105.921 115.136Z",
    fill: "#165B95"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 62.6084H81.0548C81.8302 62.6038 84.0684 63.18 82.2842 65.6732C77.9963 71.0543 75.3709 78.2843 75.3709 86.2338C75.3709 94.1834 77.9963 101.413 82.2842 106.794C84.0684 109.287 81.8302 109.863 81.0548 109.859H51V62.6084Z",
    fill: "#AED5F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.163 62.6084H130.617C129.838 62.6038 127.589 63.18 129.382 65.6732C133.69 71.0543 136.328 78.2843 136.328 86.2338C136.328 94.1834 133.691 101.413 129.382 106.794C127.589 109.287 129.837 109.863 130.617 109.859H146.163V62.6084Z",
    fill: "#AED5F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.922 109.83C118.164 109.83 128.088 99.2652 128.088 86.2332C128.088 73.2012 118.164 62.6367 105.922 62.6367C93.6792 62.6367 83.7549 73.2012 83.7549 86.2332C83.7549 99.2652 93.6792 109.83 105.922 109.83Z",
    fill: "#E2F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.923 84.9229C121.625 80.7173 119.903 76.9397 117.27 74.1364C114.696 71.3967 111.251 69.5837 107.412 69.2077C105.047 68.9763 104.986 65.8582 107.61 66.1047C112.181 66.5328 116.289 68.687 119.354 71.9497C122.494 75.2911 124.539 79.794 124.87 84.7944C125.021 87.0829 122.07 87.0066 121.923 84.9229ZM122.756 88.3163C123.642 88.3163 124.361 89.081 124.361 90.0251C124.361 90.9692 123.643 91.734 122.756 91.734C121.87 91.734 121.15 90.9692 121.15 90.0251C121.15 89.081 121.869 88.3163 122.756 88.3163Z",
    fill: "#AED5F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1924 102.987C95.1833 105.576 100.024 107.695 106.006 107.718C111.987 107.742 116.843 105.661 116.852 103.072C116.861 100.482 112.02 98.3638 106.039 98.3403C100.058 98.3169 95.2015 100.397 95.1924 102.987Z",
    fill: "white",
    fillOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2146_63583",
    x: 0.318199,
    y: 0.386369,
    width: 196.527,
    height: 174.366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.06817
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.3409
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.203922 0 0 0 0 0.356863 0 0 0 0 0.435294 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2146_63583"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2146_63583",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2146_63583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 175,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhoto);
export default __webpack_public_path__ + "static/media/noPhoto.8fa0ab4adb6017f360f7662e211f3f14.svg";
export { ForwardRef as ReactComponent };